
import React from 'react';
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { User } from 'lucide-react';

interface EmptyContactsStateProps {
  onAddContact: () => void;
}

const EmptyContactsState: React.FC<EmptyContactsStateProps> = ({ onAddContact }) => {
  return (
    <Card className="border-dashed border-2 bg-muted/20">
      <CardContent className="flex flex-col items-center justify-center p-12 md:p-16">
        <div className="rounded-full bg-gradient-to-br from-primary/10 to-primary/5 p-5 mb-6">
          <User className="h-8 w-8 text-primary" />
        </div>
        <h3 className="text-xl font-semibold mb-2">No contacts added yet</h3>
        <p className="text-muted-foreground text-center mb-6 max-w-md">
          Add key contacts to keep track of important people associated with this lead. Store their contact information and notes in one place.
        </p>
        <Button onClick={onAddContact} size="lg" className="shadow-sm hover:shadow-md transition-all">
          Add First Contact
        </Button>
      </CardContent>
    </Card>
  );
};

export default EmptyContactsState;
